import styled from "styled-components";

export const Component = styled.li`
	display:block;
	a {
		color:black;
	}

`;
